import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("demo@tracker.piratetrader.com");
  const [password, setPassword] = useState("demo1234");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("AUTHENTICATED");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-2 bg-[#050505] text-white">
      <div className="relative hidden lg:block overflow-hidden border-r border-[#222]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1648275913341-7973ae7bc9b3?crop=entropy&cs=srgb&fm=jpg&q=85)" }}
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 h-full p-12 flex flex-col justify-between">
          <div>
            <div className="micro-label">// momentum.terminal</div>
            <h1 className="font-heading text-5xl mt-6 leading-tight">
              MOMENTUM<br/>
              <span className="text-[#8a8a8e]">TRACKER</span>
            </h1>
            <p className="mt-4 text-sm text-[#8a8a8e] max-w-md">
              Real-time momentum scoring for the optionable universe. RSI, MACD,
              volume surge, and AI-generated tactical narratives in one terminal.
            </p>
          </div>
          <div className="font-mono-data text-xs text-[#555]">
            <div>STATUS · READY</div>
            <div>FEED · YFINANCE</div>
            <div>AI · CLAUDE SONNET 4.5</div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="micro-label mb-3">/ sign in</div>
          <h2 className="font-heading text-3xl mb-8">Access Terminal</h2>

          <label className="micro-label">Email</label>
          <input
            data-testid="login-email"
            type="email"
            value={email} onChange={e=>setEmail(e.target.value)}
            className="w-full mt-1 mb-5 px-3 py-2 bg-[#0f0f0f] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
            required
          />
          <label className="micro-label">Password</label>
          <input
            data-testid="login-password"
            type="password"
            value={password} onChange={e=>setPassword(e.target.value)}
            className="w-full mt-1 mb-6 px-3 py-2 bg-[#0f0f0f] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
            required
          />
          <button
            data-testid="login-submit"
            disabled={loading}
            className="w-full py-3 bg-white text-black hover:bg-[#00e676] hover:text-black transition-colors text-sm font-medium tracking-widest uppercase disabled:opacity-50"
          >
            {loading ? "..." : "Authenticate"}
          </button>

          <div className="mt-6 text-xs text-[#8a8a8e]">
            No account? <Link to="/register" className="text-white underline" data-testid="link-register">Register</Link>
          </div>
          <div className="mt-8 text-[10px] text-[#555] font-mono-data">
            demo · demo@tracker.piratetrader.com / demo1234
          </div>
        </form>
      </div>
    </div>
  );
}
